import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ProfileContext } from '../../Contexts/contexts';
import '../../../css/login.css';
import HeaderMinimal from '../Headers/HeaderMinimal';
import { no_waiting_element } from '../../../utils/images';
import useToast from '../../Toasts/useToast';
import {
	ToastHeaders,
	ToastMessages,
	ToastThemes,
} from '../../Toasts/ToastOptions/toastOptions';
import Services from '../../Services/services.js';

function ForgotPassword() {
	const profileContext = useContext(ProfileContext);

	const [email, setEmail] = useState('');

	const [loading, setLoading] = useState(false);

	const enqueueToast = useToast();

	const navigate = useNavigate();

	useEffect(() => {
		if (profileContext.isLogged) navigate('/');
	}, [profileContext, navigate]);

	const validateLoginForm = async (e) => {
		e.preventDefault();

		if (loading) return;

		if (!email.length) {
			enqueueToast('Vous devez remplir le champ correctement', {
				theme: ToastThemes.toastThemes.ERROR_OCCURED,
				header: ToastHeaders[ToastThemes.toastThemes.ERROR_OCCURED],
				duration: 3000,
			});

			return;
		}

		setLoading(true);

		try {
			await Services.userService.userForgotPassword(email);

			enqueueToast(
				'Vous allez recevoir votre nouveau mot de passe provisoire, vous allez être redirigé dans 5 secondes',
				{
					theme: ToastThemes.toastThemes.CONFIRM_SUCCESS,
					header: 'Mail envoyé',
					duration: 5000,
				}
			);

			setTimeout(() => {
				navigate('/login');
			}, 5000);
		} catch (error) {
			console.error(error);

			enqueueToast(ToastMessages.ERROR_OCCURED_FETCH, {
				theme: ToastThemes.toastThemes.ERROR_OCCURED,
				header: ToastHeaders[ToastThemes.toastThemes.ERROR_OCCURED],
				duration: 3000,
			});
		}
	};

	return (
		<>
			{!profileContext.isLogged && (
				<>
					<HeaderMinimal />
					<div className="login-main-container">
						<div className="login-left-side forgot-pwd-left-side">
							<div className="title-container">
								<h1 className="login-title">Mot de passe oublié</h1>
							</div>
							<form className="login-container" onSubmit={validateLoginForm}>
								<div className="mail-container relative-container">
									<input
										type="email"
										id="email"
										name="email"
										className="contact-form-input"
										autoComplete="off"
										onChange={(e) => setEmail(e.target.value)}
										value={email}
										required={true}
									/>
									<label className="contact-form-label">Adresse email</label>
								</div>
								{!loading && (
									<button
										type="submit"
										className="btn-create-account forgot-pwd-btn"
									>
										Envoyer
									</button>
								)}
							</form>
						</div>
						<div className="login-right-side">
							<img src={no_waiting_element} alt="people smiling" />
						</div>
					</div>
				</>
			)}
		</>
	);
}
export default ForgotPassword;
